import styled from "styled-components";
import { useAppDispatch } from "redux/hooks";
import { Grid } from "@mui/material";
import { useState, useEffect, useMemo, useCallback } from "react";
import { fetchTeams } from "thunk";
import useUrl from "hooks/useUrl";
import Breadcrumbs from "components/Breadcrumbs";
import Table from "components/Table";
import { useNavigate } from "react-router-dom";
import StandardPageHeader from "components/StandardPageHeader";

import useLogs from "hooks/useLogs";
import useAppNavigation from "hooks/useAppNavigation";
import { API_REQUEST_LOG, NETWORK_LOG } from "@constants";

const TableContainer = styled.div``;

const Logs = () => {
  const { queryParams, pathParams } = useUrl();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const sessionId = queryParams.get("sessionId");
  const requestId = queryParams.get("requestId");
  const { mosaicTeamId } = pathParams;
  const { navigateToTeamsTable } = useAppNavigation();

  //   const breadCrumbsItems = useMemo(() => {
  //     const items = [...defaultBreadCrumbItems];
  //     if (
  //       selectedTeam &&
  //       selectedTargetService &&
  //       selectedTargetService.id === pathParams.targetServiceId
  //     ) {
  //       items.push({
  //         text: "Go back",
  //         to: `${REPORTS_INTEGRATION_DETAILS_PATH}/teams/${selectedTeam.id}/targetServices/${selectedTargetService.name}/targetServiceId/${selectedTargetService.id}`,
  //       });
  //     }
  //     return items;
  //   }, [pathParams.targetServiceId, selectedTargetService, selectedTeam]);

  useEffect(() => {
    if (!mosaicTeamId) {
      navigateToTeamsTable();
    }

    dispatch(
      fetchTeams({
        teamIds: [mosaicTeamId],
      })
    );
  }, [dispatch, history, mosaicTeamId, navigateToTeamsTable]);

  const {
    onRequestSort: networkLogOnRequestSort,
    filtersToShow: networkLogFiltersToShow,
    filter: networkLogFilter,
    isLoading: networkLogLoadingStateById,
    hasNoData: networkLogHasNoData,
    headCells: networkLogHeadCells,
    renderTableRows: renderNetworkLogTableRows,
    isAllCollapse: networkLogIsAllCollapse,
  } = useLogs({ sessionId, teamId: mosaicTeamId, logType: NETWORK_LOG });

  const {
    onRequestSort: apiRequestLogOnRequestSort,
    filtersToShow: apiRequestLogFiltersToShow,
    filter: apiRequestLogFilter,
    isLoading: apiRequestlogLoadingStateById,
    hasNoData: apiRequestLogHasNoData,
    headCells: apiRequestLogHeadCells,
    renderTableRows: renderApiNetworkLogTableRows,
    isAllCollapse: apiRequestLogIsAllCollapse,
  } = useLogs({ requestId, teamId: mosaicTeamId, logType: API_REQUEST_LOG });

  return (
    <Grid>
      <StandardPageHeader
        title="API Request Logs"
        subtitle="View and analyze API request logs"
        icon="Logs"
        sx={{ mb: 6 }}
      />

      <Grid>
        {/* Network Log */}
        <TableContainer>
          <Table
            filter={networkLogFilter}
            tableTitle={`Network Log ${networkLogHasNoData ? "- No logs" : ""}`}
            useDefaultTable
            filtersToShow={networkLogFiltersToShow}
            useCollapseAll
            isLoading={networkLogLoadingStateById}
            headCells={networkLogHeadCells}
            isAllCollapse={networkLogIsAllCollapse}
            onRequestSort={networkLogOnRequestSort}
            renderRows={renderNetworkLogTableRows}
            hidePagination
          />
        </TableContainer>

        <TableContainer>
          <Table
            filter={apiRequestLogFilter}
            tableTitle={`Api Network Log ${
              apiRequestLogHasNoData ? "- No logs" : ""
            }`}
            useDefaultTable
            filtersToShow={apiRequestLogFiltersToShow}
            useCollapseAll
            isLoading={apiRequestlogLoadingStateById}
            headCells={apiRequestLogHeadCells}
            isAllCollapse={apiRequestLogIsAllCollapse}
            onRequestSort={apiRequestLogOnRequestSort}
            renderRows={renderApiNetworkLogTableRows}
            hidePagination
          />
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default Logs;
